<template>
  <div class="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
    <div class="row">
      <div class="col">
        <h3 class="mb-3">
          {{ $t('meetings.meetings') }}
        </h3>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="/page/home">{{ $t("site.welcome") }}</a>
            </li>
            <li
              class="breadcrumb-item active"
              aria-current="page"
            >
              {{ $t('meetings.meetings') }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <!-- end of row -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <b-tabs>
              <b-tab
                :title="$t('meetings.meetings')"
                active
              >
                <data-table :edit-item="editItem" />
              </b-tab>
              <b-tab
                v-if="userType !== 'student'"
                :title="$t('site.add')"
              >
                <my-form :new-item="newItem" />
              </b-tab>
            </b-tabs>
          </div>
          <!-- end of card body -->
        </div>
        <!-- end of card -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </div>
</template>

<script>
import DataTableVue from './components/DataTable.vue'
import FormVue from './components/Form.vue'

export default {
  name: 'MeetingsIndex',
  components: {
    'data-table': DataTableVue,
    'my-form': FormVue,
  },
  data() {
    return {
      newItem: {},
    }
  },
  methods: {
    editItem(data) {
      this.form = true
      this.newItem = data.item
    },
  },
}
</script>
